import { deepmerge } from '@utils/deepmerge'

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    maintainAspectRatio: false,
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    scales: buildChartJsOptionsPropesOption(),
  }, options)
}

const buildChartJsOptionsPropesOption = () => {
  return {
    x: {
      display: true,
      border: {
        display: true
      },
      grid: {
        display: true,
      }
    },
    y: {
      display: true,
      border: {
        display: true
      },
      grid: {
        display: false
      },
    }
  }
}
